import { configureStore } from '@reduxjs/toolkit'
import websiteConfigReducer from './websiteConfigSlice'
import authReducer from './authSlice'

export const store = configureStore({
  reducer: {
    websiteConfig: websiteConfigReducer,
    auth: authReducer,
  },
}) 